export enum FooterHeight {
  FooterBottomBarDesktop = '56px',
}
